import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';

import { CommandParams, KebabMenuComponent } from '../KebabMenu/kebab-menu.component';
import { translationLanguageOptions } from '../../data/translation-language-options';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { Subscription } from 'rxjs';
import { languageDataLocalizationMap } from '../../../../Core/Localization/language-localization.model';

export interface SuggestedPrompt {
    prompt: string;
    options?: any[];
    open?: boolean;
}

@Component({
    selector: 'agpr-ai-prompt-suggestion',
    templateUrl: './AI-prompt-suggestions.component.html',
    styleUrls: ['./AI-prompt-suggestions.component.scss'],
    standalone: false
})
export class AIPromptSuggestionComponent implements OnInit, OnDestroy {
    @Input() prompt: string;

    @Output() submitPrompt = new EventEmitter<string>();

    tryToSubmit: boolean = false;
    selectedPrompt: string;

    suggestedPrompts: SuggestedPrompt[] = [];

    @ViewChildren('kebabMenu') kebabMenus: QueryList<KebabMenuComponent>;

    translationOptions = translationLanguageOptions;
    subscriptions: Subscription[] = [];

    constructor(
        private localizationService: LocalizationService,
        private currentUserStateService: CurrentUserStateService
    ) {
        this.suggestedPrompts = [
            {
                prompt: 'Common.dialog.aiRefinement.prompt.spelling'
            },
            {
                prompt: 'Common.dialog.aiRefinement.prompt.polish'
            },
            {
                prompt: 'Common.dialog.aiRefinement.prompt.tone',
                options: [
                    {
                        key: 'Professional',
                        label: 'Common.dialog.aiHelper.contentTone.professional',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Formal',
                        label: 'Common.dialog.aiHelper.contentTone.formal',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Informal',
                        label: 'Common.dialog.aiHelper.contentTone.informal',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Fun',
                        label: 'Common.dialog.aiHelper.contentTone.fun',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Friendly',
                        label: 'Common.dialog.aiHelper.contentTone.friendly',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Optimistic',
                        label: 'Common.dialog.aiHelper.contentTone.optimistic',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Assertive',
                        label: 'Common.dialog.aiHelper.contentTone.assertive',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Cooperative',
                        label: 'Common.dialog.aiHelper.contentTone.cooperative',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Sincere',
                        label: 'Common.dialog.aiHelper.contentTone.sincere',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                    {
                        key: 'Humorous',
                        label: 'Common.dialog.aiHelper.contentTone.humorous',
                        command: (event: CommandParams) => this.setPromptOption(event)
                    },
                ]
            },
            {
                prompt: 'Common.dialog.aiRefinement.prompt.concise'
            },
            {
                prompt: 'Common.dialog.aiRefinement.prompt.expand'
            }
        ];
    }

    ngOnInit(): void {
        this.prompt = this.localizationService.transform(this.prompt);
        this.subscriptions.push(
            this.currentUserStateService.getUILanguageTag().subscribe(tag => {
                this.suggestedPrompts.push({
                    prompt: 'Common.dialog.aiRefinement.prompt.translate',
                    options: [...translationLanguageOptions].map(option => {
                        return {
                            key: option.value,
                            label: languageDataLocalizationMap[tag + '.' + option.subLabel],
                            command: (event: CommandParams) => this.setPromptOption(event)
                        };
                    })
                });
            })
        );
    }

    submitRefinementPrompt() {
        this.tryToSubmit = false;
        if (this.prompt) {
            this.submitPrompt.emit(this.prompt);
        } else {
            this.tryToSubmit = true;
        }
    }

    setPrompt(event, suggestedPrompt: SuggestedPrompt) {
        event.stopPropagation();
        this.kebabMenus.forEach(element => {
            if (element?.data?.prompt === suggestedPrompt?.prompt) {
                if (element?.panelVisible) {
                    element.hide();
                } else {
                    element.show();
                }
            } else {
                element.hide();
            }
        });
        if (!suggestedPrompt.options) {
            this.prompt = suggestedPrompt.prompt;
            this.submitRefinementPrompt();
        }
        this.selectedPrompt = suggestedPrompt.prompt;
    }

    clearSelectedPrompt() {
        this.selectedPrompt = '';
    }

    setPromptOption(event: CommandParams) {
        if (event?.originalEvent) {
            event.originalEvent.stopPropagation();
        }
        if (event?.item?.key && event?.data?.prompt) {
            this.prompt =
                this.localizationService.transform(event?.data?.prompt) + ' '
                + this.localizationService.transform(event?.item?.label);
        }
        this.submitRefinementPrompt();
    }

    hideMenu(){
        // TODO -> it closes it to fast
        // this.kebabMenus.forEach(button => button.hide());
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
